export interface IApplicationBannerCfgData {
    discussionsTop?: string;
}

export class ApplicationBannerCfgJs {

    private discussionsTopSlot: number;

    constructor(json: IApplicationBannerCfgData) {
        this.discussionsTopSlot = +json.discussionsTop!;
    }

    getDiscussionsTopSlot(): number {
        return this.discussionsTopSlot;
    }
}